import React, { useCallback, useMemo, useState } from "react";
import style from "./index.module.scss";
import Viewer from "react-viewer";
import { Icon, Tooltip } from "antd";

export default function FilesList({ list }: { list: string[] }) {
    const [visible, setVisible] = useState(false);
    const [activeIndex, setActiveIndex] = useState<number>(0);

    //预览图片
    const viewerSrc = useMemo(() => {
        return list?.map(item => ({ src: item, alt: "" }));
    }, [list]);

    const handleClick = useCallback((index: number) => {
        setVisible(true);
        setActiveIndex(index);
    }, []);

    const handleDownload = (url: string) => {
        window.open(url);
    };

    function getName(url: string) {
        return url.split("attname=").pop()?.split("&key")[0];
    }
    return (
        <div className={style.listWrapper}>
            {list.map((item: string, index) => (
                <div key={index}>
                    <div className={style.item}>
                        <img
                            src={item}
                            alt=""
                            onClick={() => handleClick(index)}
                        />
                        <div className={style.mask}>
                            <Icon
                                type="eye"
                                onClick={() => handleClick(index)}
                            />
                            <Icon
                                type="download"
                                onClick={() => handleDownload(item)}
                            />
                        </div>
                    </div>

                    <div className={style.name}>
                        <Tooltip placement="topLeft" title={getName(item)}>
                            {getName(item)}
                        </Tooltip>
                    </div>
                </div>
            ))}

            <Viewer
                visible={visible}
                activeIndex={activeIndex}
                onClose={() => setVisible(false)}
                images={viewerSrc}
            />
        </div>
    );
}
